import { Injectable } from "@angular/core";
import { MappedExportTemplate } from "app/models/export-templates/export-template.models";
import {
  ExportRequestModel,
  ExportRequestModelList,
} from "swagger-gen/web-secured/models";

@Injectable({
  providedIn: "root",
})
export class ExportTemplateMapper {

  public mapEntities(entities: ExportRequestModelList): MappedExportTemplate[] {
    return entities.map(this.mappeEntity);
  }

  public mappeEntity(entity: ExportRequestModel): MappedExportTemplate {
    return {
      id: entity.uid ?? '', // Map the UID to "id"
      name: entity.name, // Keep the name
      creator: entity.createdBy ?? '', // Map the createdBy to "creator"
      createdOn: entity.createdAt ?? '', // Map createdAt to "createdOn"
      lastModifiedBy: entity.modifiedBy ?? '', // Map modifiedBy to "lastModifiedBy"
      lastModifiedOn: entity.modifiedAt ?? '', // Map modifiedAt to "lastModifiedOn"
      sheetTitles: entity.sheetNames, // Map sheetNames to sheetTitles
    };
  }
}
